import React from "react";
import PropTypes from "prop-types";
import { Field, Control, Label, Input, Column } from "rbx";

import {
  SystemCodeSelect,
  SocialSecurityInput,
  PoorTextEditor,
  DateInput,
  BooleanInput,
  EmployeeSelect
} from "../../../../components/inputs";

import HorizontalRule from "../../../../styles/HorizontalRule";
import { useAuthorization } from "../../../../components/Authorization";
import DriversAndMechanics from "../components/DriversAndMechanics";

function Payroll({ employee, editing, onChange, mechanicTypeRecIdRef }) {
  const MechanicAuth = useAuthorization(["MECH"]);
  return (
    <div className="employee-tab-container">
      <Column.Group>
        <Column size={2}>
          <Field>
            <Control>
              <Label>Payroll Id</Label>
              <Input
                autocomplete="new"
                name="PayrollId"
                readOnly={!editing}
                type="text"
                value={employee.PayrollId}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column size={2}>
          <Field>
            <Control>
              <Label>Job Title</Label>
              <Input
                autocomplete="new"
                name="JobTitle"
                readOnly={!editing}
                type="text"
                value={employee.JobTitle}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column size={2}>
          <Field>
            <Control>
              <SystemCodeSelect
                required
                icon="globe"
                label="Employee Type"
                lookup={{
                  Category: "Employee",
                  Code: "EmployeeType"
                }}
                name="EmployeeTypeRecIdRef"
                readOnly={!editing}
                value={employee.EmployeeTypeRecIdRef}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column size={2}>
          <Control>
            <EmployeeSelect
              icon="globe"
              label="Supervisor"
              name="SupervisorRecIdRef"
              readOnly={!editing}
              value={employee.SupervisorRecIdRef}
              variables={{
                where: { EmployeeTypeRecIdRef: 96, Active: true },
                orderByMulti: ["LastName_ASC"]
              }}
              onChange={onChange} // Executive Level
            />
          </Control>
        </Column>
        <Column size={1}>
          <Field>
            <Control>
              <Label>SSN (Last 4)</Label>
              <SocialSecurityInput
                name="SocialSecurityNo"
                readOnly={!editing}
                value={employee.SocialSecurityNo}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field kind="group">
            <Control>
              <Label>Veteran</Label>
              <BooleanInput
                name="Veteran"
                readOnly={!editing}
                value={employee.Veteran}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>Driver</Label>
              <BooleanInput
                name="DriverFlag"
                readOnly={!editing}
                value={employee.DriverFlag}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>Mechanic</Label>
              <BooleanInput
                name="MechanicFlag"
                readOnly={!editing}
                value={employee.MechanicFlag}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>Drug Test</Label>
              <BooleanInput
                name="DrugTest"
                readOnly={!editing || !employee.DriverFlag}
                value={employee.DrugTest}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>Shop Steward</Label>
              <BooleanInput
                name="ShopSteward"
                readOnly={!editing || !employee.DriverFlag}
                value={employee.ShopSteward}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <Column.Group>
        <Column size={2}>
          <Field>
            <Control>
              <Label>Birth Date</Label>
              <DateInput
                name="BirthDate"
                readOnly={!editing}
                value={employee.BirthDate}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column size={2}>
          <Field>
            <Control>
              <Label>Hire Date</Label>
              <DateInput
                name="HireDate"
                readOnly={!editing}
                value={employee.HireDate}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column size={2}>
          <Field>
            <Control>
              <Label>Termination Date</Label>
              <DateInput
                name="TerminationDate"
                readOnly={!editing}
                value={employee.TerminationDate}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column size={2}>
          <Field>
            <Control>
              <SystemCodeSelect
                icon="globe"
                label="Termination Reason"
                lookup={{ Category: "Employee", Code: "TermReason" }}
                name="TerminationReasonRecIdRef"
                readOnly={!editing}
                required={!!employee.TerminationDate}
                value={employee.TerminationReasonRecIdRef}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column size={2}>
          <Field>
            <Control>
              <Label>Rehire Date</Label>
              <DateInput
                name="RehireDate"
                readOnly={!editing}
                value={employee.RehireDate}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <DriversAndMechanics
        MechanicAuth={MechanicAuth}
        editing={editing}
        employee={employee}
        mechanicTypeRecIdRef={mechanicTypeRecIdRef}
        onChange={onChange}
      />
      <HorizontalRule />
      <Column.Group>
        <Column size="half">
          <Field>
            <Control expanded>
              <Label>Payroll Note</Label>
              <PoorTextEditor
                name="PayrollNote"
                readOnly={!editing}
                value={employee.PayrollNote}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
        <Column size="half">
          <Field>
            <Control expanded>
              <Label>Termination Note</Label>
              <PoorTextEditor
                name="TerminationNote"
                readOnly={!editing}
                value={employee.TerminationNote}
                onChange={onChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
    </div>
  );
}

Payroll.propTypes = {
  onChange: PropTypes.func,
  employee: PropTypes.object,
  editing: PropTypes.bool,
  mechanicTypeRecIdRef: PropTypes.number
};
Payroll.defaultProps = {
  employee: {}
};
export default Payroll;
